export default "__VITE_ASSET__42d6c9c7__"